/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaSourceActivityAndSourceForPeriod from './AqaSourceActivityAndSourceForPeriod';
import Invoice from './Invoice';

/**
 * The AqaStatement model module.
 * @module model/AqaStatement
 * @version v0
 */
export default class AqaStatement {
  /**
   * Constructs a new <code>AqaStatement</code>.
   * @alias module:model/AqaStatement
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaStatement</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaStatement} obj Optional instance to populate.
   * @return {module:model/AqaStatement} The populated <code>AqaStatement</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaStatement();
      if (data.hasOwnProperty('year'))
        obj.year = ApiClient.convertToType(data['year'], 'Number');
      if (data.hasOwnProperty('month'))
        obj.month = ApiClient.convertToType(data['month'], 'Number');
      if (data.hasOwnProperty('invoice'))
        obj.invoice = Invoice.constructFromObject(data['invoice']);
      if (data.hasOwnProperty('activities'))
        obj.activities = ApiClient.convertToType(data['activities'], [AqaSourceActivityAndSourceForPeriod]);
      if (data.hasOwnProperty('numberOfUsers'))
        obj.numberOfUsers = ApiClient.convertToType(data['numberOfUsers'], 'Number');
      if (data.hasOwnProperty('numberOfSources'))
        obj.numberOfSources = ApiClient.convertToType(data['numberOfSources'], 'Number');
      if (data.hasOwnProperty('currencyCode'))
        obj.currencyCode = ApiClient.convertToType(data['currencyCode'], 'String');
      if (data.hasOwnProperty('blockSize'))
        obj.blockSize = ApiClient.convertToType(data['blockSize'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} year
 */
AqaStatement.prototype.year = undefined;

/**
 * @member {Number} month
 */
AqaStatement.prototype.month = undefined;

/**
 * @member {module:model/Invoice} invoice
 */
AqaStatement.prototype.invoice = undefined;

/**
 * @member {Array.<module:model/AqaSourceActivityAndSourceForPeriod>} activities
 */
AqaStatement.prototype.activities = undefined;

/**
 * @member {Number} numberOfUsers
 */
AqaStatement.prototype.numberOfUsers = undefined;

/**
 * @member {Number} numberOfSources
 */
AqaStatement.prototype.numberOfSources = undefined;

/**
 * @member {String} currencyCode
 */
AqaStatement.prototype.currencyCode = undefined;

/**
 * @member {Number} blockSize
 */
AqaStatement.prototype.blockSize = undefined;

